import { Component, ViewChild, Renderer2 } from '@angular/core';
import { IonInfiniteScroll, DomController, NavController, IonContent, IonToolbar, IonHeader, AlertController, LoadingController, Platform, ModalController } from '@ionic/angular';
import { BasePage } from 'src/pages/base.page';
import { Router, ActivatedRoute } from '@angular/router';

import { AtivoModel } from 'projects/core/src/lib/core/model/AtivoModel'
import { DetalhesAtivoViewModel } from './DetalhesAtivoViewModel';
import { DetalhesAtivoModel } from 'projects/core/src/lib/core/model/DetalhesAtivoModel';
import { AlertComponent } from 'projects/core/src/lib/core/Alert.component';
import { LoadingComponent } from 'projects/core/src/lib/core/Loading.component';
import { ThrowError } from 'projects/core/src/lib/core/ThrowError';
import { DataUtil } from 'projects/core/src/lib/core/DataUtil';
import { ContratoWrapperModel } from 'projects/core/src/lib/core/model/ContratoWrapperModel';
import { HelperMenuContrato } from 'projects/core/src/lib/core/HelperMenuContrato';
import { ContratoMenuModel } from 'projects/core/src/lib/core/model/ContratoMenuModel';
import { ChaveContratoEnum } from 'projects/core/src/lib/core/ChaveContratoEnum';
import { RecomendacaoMenuModel } from 'projects/core/src/lib/core/model/RecomendacaoMenuModel';
import { PlanoDialog } from 'src/pages/plano/plano.dialog';
import { NavegaTelaPlanoImpl } from 'src/pages/plano-ios/NavegaTelaPlanoImpl';

import { Style, StatusBar } from '@capacitor/status-bar';

@Component({
  selector: 'detalhes-ativo',
  templateUrl: 'detalhes-ativo.page.html',
  styleUrls: ['detalhes-ativo.page.scss']
})
export class DetalhesAtivoPage extends BasePage implements NavegaTelaPlanoImpl {

  @ViewChild(IonInfiniteScroll) infiniteScroll: IonInfiniteScroll;
  @ViewChild(IonContent) content: IonContent;
  @ViewChild(IonToolbar) toolbar: IonToolbar;
  @ViewChild(IonHeader) header: IonHeader;

  tituloPagina: string
  iconePagina: string
  backgroundPagina: string
  corTextoPagina: string
  tipoPagina: Number
  ativo: AtivoModel = new AtivoModel()
  tipoAtivo: string
  idAtivo: Number
  statusAtivo: string
  backgroundToolbar: string
  context: DetalhesAtivoPage
  detalhesAtivoViewModel: DetalhesAtivoViewModel
  alertComponent: AlertComponent
  loadingComponent: LoadingComponent
  graficoAtivo: String = ''
  fadeIn: boolean = false
  contratoWrapper: ContratoWrapperModel

  PAGINA_COMPRA = 1
  PAGINA_VENDA = 2
  PAGINA_COMPRA_ENCERRADA = 3
  PAGINA_VENDA_ENCERRADA = 4

  STATUS_ABERTO = 'aberto'
  STATUS_ENCERRADO = 'encerrado'

  TIPO_COMPRA = 'compra'
  TIPO_VENDA = 'venda'

  dataEntrada: String
  horaEntrada: String
  dataSaida: String
  horaSaida: String
  requisicaoRealizada = false
  textoJuridico = "As informações, gráficos e relatórios constantes no aplicativo foram elaborados pela PHICUBE TECNOLOGIA E INOVAÇÃO LTDA (“PHICUBE”) em conformidade com as disposições da Resolução CVM nº 20/2021, de 25/02/2021 para informar os clientes e usuários acerca de avisos de ações, fomentando o conhecimento e auxiliando-os a tomar suas próprias decisões de investimento. O conteúdo deste relatório foi elaborado pelo nosso analista de valores mobiliários, devidamente credenciado e cumpridor do Código de Conduta da APIMEC para analistas de valores mobiliários e responsável pelo atendimento das normas constantes da Resolução CVM nº 20/2021. Todas as informações deste relatório refletem a opinião pessoal de nosso analista, tendo sido elaborado de forma independente, inclusive em relação à PHICUBE, com total autonomia e completamente isento de qualquer uma das situações que poderiam afetar a imparcialidade de tal analista ou da PHICUBE, bem como qualquer outro evento que, direta ou indiretamente, possa configurar conflito de interesse nos termos do disposto dos artigos 21 e 22 da Resolução CVM nº 20/2021."

  constructor(
    public renderer: Renderer2, 
    public domCtrl: DomController, 
    public navCtrl: NavController, 
    public router: Router, 
    private alertController: AlertController, 
    private loadingController: LoadingController,
    private activatedRoute: ActivatedRoute,
    private platform: Platform,
    private modalCtrl: ModalController) {
      super(router)
  }

  async ngOnInit() {
    this.iniciaVariaveis()
    this.processoExibirAtivo()
  }

  async ionViewDidEnter() {
    if (this.platform.is('ios')) {
      this.processoExibirAtivo()
      this.platform.resume.subscribe(async (res) => {
        this.processoExibirAtivo()
      })
    }
    setTimeout(() => {
      this.requisicaoRealizada = false
    }, 2000)
  }

  iniciaVariaveis() {
    this.idAtivo = Number.parseInt(this.activatedRoute.snapshot.paramMap.get('idAtivo'));
    this.tipoAtivo = this.activatedRoute.snapshot.paramMap.get('tipoAtivo');
    this.detalhesAtivoViewModel = new DetalhesAtivoViewModel()
    this.detalhesAtivoViewModel.setContext(this)
    this.loadingComponent = new LoadingComponent(this.loadingController)
  }

  async processoExibirAtivo() {
    if (!this.requisicaoRealizada) {
      this.requisicaoRealizada = true
      try {
        await this.validaPermissaoAcessoPagina()
        await this.buscaAtivo()
        this.configuraPagina()
      } catch (e) {
        this.openPage('/navigation/home')
      }
    }
  }

  async buscaAtivo() {
    const loading = await this.showLoading()
    try {
      await this.detalhesAtivoViewModel.getAtivo(this.idAtivo)
    } catch (e) {
      this.showAlert(ThrowError.TITLE_DEFAULT, ThrowError.MESSAGE_DEFAULT)
      this.openPage("")
    }
    if (loading != null) {
      loading.dismiss()
    }
  }

  async showLoading() {
    return await this.loadingComponent.showLoading()
  }

  showAlert(title: string, message: string) {
    AlertComponent.showAlert(title, message)
  }

  eventScroll(event) {
    const rootPage = document.getElementsByTagName('detalhes-ativo')[0];

    const ionHeader = rootPage.getElementsByTagName('ion-toolbar')[0]
    //const ionTitle = rootPage.getElementsByTagName('ion-title')[0]
    const ionBackButton = rootPage.getElementsByTagName('ion-back-button')[0]

    if(event.detail.scrollTop === 0){
      ionHeader.style.backgroundColor = "transparent"
      ionHeader.style.boxShadow = "none"
      //ionTitle.style.color = this.corTextoPagina.toString()
      ionBackButton.style.color = this.corTextoPagina.toString()
    }
    else if(event.detail.scrollTop > 0){
      ionHeader.style.backgroundColor = "rgba(255, 255, 255, .9)"
      ionHeader.style.boxShadow = "rgba(0, 0, 0, 0.2) 0px 2px 3px 0px"
      //ionTitle.style.color = "#5081ff"
      ionBackButton.style.color = "#5081ff"
    }
  }

  setAtivo(ativo: DetalhesAtivoModel) {
    this.ativo = ativo
    
    this.dataEntrada = this.getDataAtivo(this.ativo.data_entrada)
    this.horaEntrada = this.getHoraAtivo(this.ativo.data_entrada)

    this.dataSaida = this.getDataAtivo(this.ativo.data_saida)
    this.horaSaida = this.getHoraAtivo(this.ativo.data_saida)

    this.graficoAtivo = this.ativo.grafico_img
  }

  getDataAtivo(data: String) {
    if (data == '' || data == null) return ''
    return DataUtil.getDataHoraServidor(data.toString(), DataUtil.EXPORT_DATE)
  }

  getHoraAtivo(data: String) {
    if (data == '' || data == null) return ''
    return DataUtil.getDataHoraServidor(data.toString(), DataUtil.EXPORT_HOUR)
  }

  trataDataHora(dataHora: string): string {
    return dataHora.replace(" ", "T")
  }

  addHours(d, h) {
    d.setTime(d.getTime() + (h*60*60*1000));
    return d;
  }

  async validaPermissaoAcessoPagina() {
    await this.buscaContratos()

    let chaveContrato;

    switch(this.tipoAtivo) {
      case RecomendacaoMenuModel.TIPO_ACOES_BOLSA:
        chaveContrato = ChaveContratoEnum.CONTRATO_RECOMENDACAO_ACOES
        break;
      case RecomendacaoMenuModel.TIPO_CRIPTOMOEDAS:
          chaveContrato = ChaveContratoEnum.CONTRATO_RECOMENDACAO_CRIPTOMOEDAS
        break;
      case RecomendacaoMenuModel.TIPO_FUNDOS_IMOBILIARIOS:
          chaveContrato = ChaveContratoEnum.CONTRATO_RECOMENDACAO_FUNDOS_IMOBILIARIOS
        break;
      case RecomendacaoMenuModel.TIPO_FUNDOS_INDICE:
          chaveContrato = ChaveContratoEnum.CONTRATO_RECOMENDACAO_FUNDOS_INDICES
        break;
      case RecomendacaoMenuModel.TIPO_INDICES:
          chaveContrato = ChaveContratoEnum.CONTRATO_RECOMENDACAO_INDICES
        break;
      case RecomendacaoMenuModel.TIPO_EUA:
          chaveContrato = ChaveContratoEnum.CONTRATO_RECOMENDACAO_EUA
        break;
    }

    let item = new ContratoMenuModel()
    item.active = true
    item.chaveContrato = [chaveContrato]

    if (!await HelperMenuContrato.validaMenu(item)) {
      throw Error(ThrowError.MESSAGE_DEFAULT)
    }
  }
  
  async navegaTelaPlano(urlContratar) {
    const modalBoasVindas = await this.modalCtrl.create({
      component: PlanoDialog,
      componentProps: {
        urlContratar
      }
    });
    modalBoasVindas.present();
  }

  async buscaContratos() {
    try {
      await this.detalhesAtivoViewModel.buscaContratos()
    } catch (e) {
      this.showAlert(ThrowError.TITLE_DEFAULT, ThrowError.MESSAGE_DEFAULT)
    }
  }

  setListaContratos(contratoWrapper: ContratoWrapperModel) {
    this.contratoWrapper = contratoWrapper
  }

  btnAbrirGrafico(ativo: AtivoModel) {
    let url = '/navigation/recomendacoes/ativo/' + this.ativo.id + '/' + this.encodeData({
      codigo_ativo: ativo.codigo_ativo,
      gr_entrada: ativo.gr_entrada,
      gr_objetivo: ativo.gr_objetivo,
      gr_stop: ativo.gr_stop,
      gr_date: ativo.gr_date,
      gr_timeframe: ativo.gr_timeframe
    }) + '/grafico'
    this.openPage(url)
  }

  configuraPagina() {
    this.fadeIn = true
    if (this.ativo.encerrada == false) {
      this.backgroundPagina = "../../../assets/img/top-img.png"
      this.corTextoPagina = "#FFFFFF"

      switch (this.ativo.compra) {
        case 1:
          this.tituloPagina = "RECOMENDAÇÃO<br><strong>DE COMPRA</strong>"
          this.iconePagina = "../../../assets/img/icon-compra-md.svg"
          break;
        case 0:
          this.tituloPagina = "RECOMENDAÇÃO<br><strong>DE VENDA</strong>"
          this.iconePagina = "../../../assets/img/icon-venda-md.svg"
          break;
      }
    } else {
      
      this.iconePagina = "../../../assets/img/icon-encerrada-md.svg"
      this.backgroundPagina = "../../../assets/img/top-img-2.png"
      this.corTextoPagina = "#5081ff"

      switch (this.ativo.compra) {
        case 1:
          this.tituloPagina = "COMPRA<br><strong>ENCERRADA</strong>"
          break;
        case 0:
          this.tituloPagina = "VENDA<br><strong>ENCERRADA</strong>"
          break;
      }

      if (this.platform.is('ios'))
        setTimeout(() => {
          StatusBar.setStyle({
            style: Style.Light
          });
        }, 1000)
    }
  }
}
